import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CurrencyInput from "./CurrencyInput";
import api from "../api";

const ModalTripClosure = ({ isOpen, onClose, element, onTripClosure }) => {
  const [error, setError] = useState(null);
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState(1);

  const [bill, setBill] = useState("");
  const [voucher, setVoucher] = useState("");
  const [payMethod, setPayMethod] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");

  const [fieldErrors, setFieldErrors] = useState({});

  const paymentMethodOptions = [
    { value: 1, label: "Tarjeta" },
    { value: 2, label: "Efectivo" },
    { value: 3, label: "Transferencia" },
  ];

  const paymentConditionOptions = [
    { value: 1, label: "Al contado" },
    { value: 2, label: "A crédito" },
  ];

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setFieldErrors({});

    const data = {
      amount: +amount,
      currency: +currency,
      invoice_number: bill,
      voucher_number: voucher,
      payment_method: +payMethod,
      payment_condition: +paymentCondition,
    };

    try {
      await api.rides.tripClosure(element?.id, data);
      onTripClosure();
      onClose(); // Cierra el modal después de guardar
      // Reinicia los valores del formulario
      setAmount("");
      setBill("");
      setPayMethod("");
      setPaymentCondition("");
    } catch (error) {
      if (error.message) {
        setFieldErrors(error.message); // Ajustar esto según la estructura del error
      } else {
        setError("Ocurrió un error al enviar los datos.");
      }
    }
  };

  useEffect(() => {
    if (isOpen && element?.voucherNumber) {
      setVoucher(element.voucherNumber);
    }
  }, [isOpen, element]);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        {/* Fondo oscuro */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-6">
            {/* Animación del panel */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <Dialog.Panel className="relative bg-white rounded-lg shadow-lg md:w-[480px] p-10">
                {/* Título */}
                <Dialog.Title
                  as="h2"
                  className="poppins-medium text-[18px] text-center text-[#1F384C] tracking-wide mb-[29px]"
                >
                  Cierre del viaje
                </Dialog.Title>

                <div className="flex flex-col space-y-6 mb-[52px]">
                  <div>
                    <CurrencyInput
                      amount={amount}
                      setAmount={setAmount}
                      currency={currency}
                      setCurrency={setCurrency}
                    />
                    {fieldErrors.amount && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.amount[0]}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Nº de factura"
                      value={bill}
                      onChange={(e) => setBill(e.target.value)}
                      className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-12 focus:outline-none focus:ring"
                    />

                    {fieldErrors.invoice_number && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.invoice_number[0]}
                      </p>
                    )}
                  </div>

                  <div>
                    {voucher && (
                      <label
                        htmlFor="voucher"
                        className="text-[#8F99A6] text-xs tracking-wider"
                      >
                        Nº de voucher
                      </label>
                    )}
                    <input
                      id="voucher"
                      type="text"
                      placeholder="Nº de voucher"
                      value={voucher}
                      className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-12 focus:outline-none focus:ring"
                      onChange={(e) => setVoucher(e.target.value)}
                    />

                    {fieldErrors.invoice_number && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.invoice_number[0]}
                      </p>
                    )}
                  </div>

                  <div>
                    <select
                      value={payMethod}
                      onChange={(e) => setPayMethod(e.target.value)}
                      className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-12 focus:outline-none focus:ring"
                      style={{ color: payMethod === "" ? "#C9C9C9" : "" }}
                    >
                      <option value="" disabled hidden>
                        Método de pago
                      </option>
                      {paymentMethodOptions.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {fieldErrors.payment_method && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.payment_method[0]}
                      </p>
                    )}
                  </div>

                  <div>
                    <select
                      value={paymentCondition}
                      onChange={(e) => setPaymentCondition(e.target.value)}
                      className="poppins-medium text-xs bg-[#F9FAFB] w-full rounded-md py-4 px-[23px] pr-12 focus:outline-none focus:ring"
                      style={{
                        color: paymentCondition === "" ? "#C9C9C9" : "",
                      }}
                    >
                      <option value="" disabled hidden>
                        Selecciona una opcion
                      </option>
                      {paymentConditionOptions.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {fieldErrors.payment_condition && (
                      <p className="text-red-600 text-sm">
                        {fieldErrors.payment_condition[0]}
                      </p>
                    )}
                  </div>
                </div>

                {error && <p className="text-red-600 mb-4">{error}</p>}

                {/* Botón de cierre */}
                <button
                  onClick={handleFormSubmit}
                  className={`bg-[#BE202F] w-full text-white text-xs py-4 px-4 rounded-2xl tracking-wider poppins-medium focus:outline-none`}
                >
                  Cerrar viaje
                </button>

                {/* Botón de cerrar */}
                <button
                  onClick={onClose}
                  className="absolute top-4 right-4 text-[#000000] hover:text-gray-600 focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    className="w-8 h-8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalTripClosure;
